import { Spinner } from '@/components/Spinner';
import { useMainPageGroupDetail } from '../hooks/useMainPageGroupDetail';
import { MainPageGroupForm } from './MainPageGroupForm';

export const EditGroupFormContainer = ({ groupId }: { groupId: string }) => {
  const { mainPageGroupDetail, isLoading } = useMainPageGroupDetail(groupId);
  const defaultValues = {
    groupName: mainPageGroupDetail?.groupName ?? '',
    description: mainPageGroupDetail?.remark ?? '',
  };
  return isLoading ? <Spinner /> : <MainPageGroupForm defaultValues={defaultValues} groupId={groupId} />;
};
